// The dropdown layer id openOrgSwitcherMenu opens the org switcher under.
// Shared so the workspace shell's Panel pin
// (workspace/functions/orgSwitcherPanelPin.js) matches the same layer
// without a copy of the string.
export const ORG_SWITCHER_DROPDOWN_ID = 'appOrgSwitcher'
